import { useMemo } from "react";
import { useLLMModels } from "@/api/hooks";
import type { AIModel } from "../store/ai-model-store";

export const useAIModelBackend = (
  enabled: boolean = false,
  searchTerm: string = ""
) => {
  const {
    data: modelsResponse,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useLLMModels({
    limit: 20,
    provider_type: "generative",
    searchTerm,
    enabled,
  });

  // Process data like conversations - no store sync!
  // Eachalab modelleri AIModel ile birebir uyumlu

  const models = useMemo(() => {
    if (!modelsResponse?.pages) return [];
    return modelsResponse.pages.flatMap(
      (page: any) => page.data.result
    ) as AIModel[];
  }, [modelsResponse]);

  const totalCount = useMemo(() => {
    if (!modelsResponse?.pages?.[0]) return 0;
    return (modelsResponse.pages[0] as any).data.meta.total;
  }, [modelsResponse]);

  // Load more function
  const handleLoadMore = async () => {
    if (hasNextPage && !isFetchingNextPage) {
      await fetchNextPage();
    }
  };

  return {
    models,
    totalCount,
    isLoading,
    error,
    refetch,
    loadMore: handleLoadMore,
    hasNextPage,
    isLoadingMore: isFetchingNextPage,
  };
};
